'use strict';

const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;

function parse(reader) {
    let count;
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readUInt8("data.mobile_signal");
    reader.readBit(1, "data.din");
    reader.readBit(1, "data.dout");
    count = reader.readUInt8("data.ain_1.count");
    reader.readUInt32LE("data.ain_1.time_step");
    reader.readFloatLEInBatch(count, 0, "data.ain_1.values");
    count = reader.readUInt8("data.ain_2.count");
    reader.readUInt32LE("data.ain_2.time_step");
    reader.readFloatLEInBatch(count, 0, "data.ain_2.values");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/analog/regular-report-parser.js